// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3m-Zt","header":"ReportDetails_header__2-8ye","title":"ReportDetails_title__wnF7_","left":"ReportDetails_left__1FFQW"};